import MyPaper from './MyPaper'

export default MyPaper
